<template>
  <v-layout row>
    <v-flex  class="pl-4 pr-4 mt-3 mb-4">
      <v-card>
        <v-toolbar color="grey" dark>
          <!--<v-toolbar-side-icon></v-toolbar-side-icon>-->
          <v-toolbar-title>Usuarios</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="blue" icon>
            <v-icon>mdi-search</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  //name: "LoginLayout",

  props: {
    source: String
  },
  data() {
    return {};
  },

  created() {
    this.$store.commit("SET_LAYOUT", "dashboard-layout");
  }
};
</script>